var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell",class:{'is-grow': !_vm.width, 'is-right': _vm.right},style:({width: _vm.styleWidth})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }